import { createAction } from 'typesafe-actions';
import { PopupOrderItem, PopupType } from '../../types/state/ui/PopupOrderState';

const init = createAction('ui/popup-order/INIT', 
    resolve => (order: PopupOrderItem[]) => resolve({ order }));
const markAsShown = createAction('ui/popup-order/MARK_SHOWN');
const markAsWait = createAction(
    'ui/popup-order/MARK_WAIT',
    resolve => (popupType: PopupType) => resolve({ popupType })
);

export const popupOrderActions = {
    init,
    markAsShown,
    markAsWait,
}
